import type { CatalogMedia } from "../domain/types";

const checkedAt = "2026-08-24";

const mangaBySeedId: Record<string, { id: string; siteUrl: string }> = {
  "154587": { id: "118586", siteUrl: "https://anilist.co/manga/118586" },
  "153518": { id: "86082", siteUrl: "https://anilist.co/manga/86082" },
  "130003": { id: "111258", siteUrl: "https://anilist.co/manga/111258" },
  "161645": { id: "99022", siteUrl: "https://anilist.co/manga/99022" },
  "530": { id: "30092", siteUrl: "https://anilist.co/manga/30092" },
  "140960": { id: "108556", siteUrl: "https://anilist.co/manga/108556" },
};

export const catalogSeed: CatalogMedia[] = [
  {
    id: "154587",
    type: "ANIME",
    title: "장송의 프리렌",
    nativeTitle: "葬送のフリーレン",
    siteUrl: "https://anilist.co/anime/154587",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx154587-qQTzQnEJJ3oB.jpg",
    description: "긴 여행 뒤의 시간을 따라가는 판타지. 레이어드 의상과 지팡이 소품을 단계별로 준비하기 좋습니다.",
    genres: ["Adventure", "Drama", "Fantasy"],
    tags: ["Travel", "Magic", "Found Family"],
    seasonYear: 2023,
    characters: [
      { id: "176754", name: "프리렌", nativeName: "フリーレン", siteUrl: "https://anilist.co/character/176754", image: "https://s4.anilist.co/file/anilistcdn/character/large/b176754-PCnpqIOkjhFk.png", role: "MAIN" },
      { id: "183965", name: "페른", nativeName: "フェルン", siteUrl: "https://anilist.co/character/183965", image: "https://s4.anilist.co/file/anilistcdn/character/large/b183965-uGFohBjlFoTp.png", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
  {
    id: "153518",
    type: "ANIME",
    title: "던전밥",
    nativeTitle: "ダンジョン飯",
    siteUrl: "https://anilist.co/anime/153518",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx153518-IVXPDY5ph3kO.jpg",
    description: "파티 모험과 요리를 엮은 판타지. 갑옷·마도서·조리 소품처럼 역할별 제작 선택지가 큽니다.",
    genres: ["Adventure", "Comedy", "Fantasy"],
    tags: ["Dungeon", "Food", "Ensemble Cast"],
    seasonYear: 2024,
    characters: [
      { id: "127292", name: "마르실", nativeName: "マルシル", siteUrl: "https://anilist.co/character/127292", image: "https://s4.anilist.co/file/anilistcdn/character/large/b127292-MAWgxbS0Cbrs.png", role: "MAIN" },
      { id: "130509", name: "칠책", nativeName: "チルチャック", siteUrl: "https://anilist.co/character/130509", image: "https://s4.anilist.co/file/anilistcdn/character/large/b130509-NFZ7xFt1kLqd.png", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
  {
    id: "130003",
    type: "ANIME",
    title: "봇치 더 록!",
    nativeTitle: "ぼっち・ざ・ろっく！",
    siteUrl: "https://anilist.co/anime/130003",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx130003-HTDmeL4RGeJ4.png",
    description: "밴드 활동을 다룬 일상 코미디. 일상복 기반 의상과 악기 소품으로 첫 프로젝트 진입 난도가 낮습니다.",
    genres: ["Comedy", "Music", "Slice of Life"],
    tags: ["Band", "Female Protagonist", "Primarily Teen Cast"],
    seasonYear: 2022,
    characters: [
      { id: "257562", name: "고토 히토리", nativeName: "後藤ひとり", siteUrl: "https://anilist.co/character/257562", image: "https://s4.anilist.co/file/anilistcdn/character/large/b257562-Ru35NYPfsqhY.png", role: "MAIN" },
      { id: "261674", name: "이지치 니지카", nativeName: "伊地知虹夏", siteUrl: "https://anilist.co/character/261674", image: "https://s4.anilist.co/file/anilistcdn/character/large/b261674-a8tJYvtzqWgC.png", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
  {
    id: "161645",
    type: "ANIME",
    title: "약사의 혼잣말",
    nativeTitle: "薬屋のひとりごと",
    siteUrl: "https://anilist.co/anime/161645",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx161645-QLbzHXiYRgV2.jpg",
    description: "궁중 미스터리와 약학을 다룬 시대물. 여러 겹의 의상과 장신구 때문에 납기·예산 계획이 중요합니다.",
    genres: ["Drama", "Mystery", "Romance"],
    tags: ["Historical", "Medicine", "Female Protagonist"],
    seasonYear: 2023,
    characters: [
      { id: "126824", name: "마오마오", nativeName: "猫猫", siteUrl: "https://anilist.co/character/126824", image: "https://s4.anilist.co/file/anilistcdn/character/large/b126824-MqsCncTO1qpv.png", role: "MAIN" },
      { id: "127278", name: "진시", nativeName: "壬氏", siteUrl: "https://anilist.co/character/127278", image: "https://s4.anilist.co/file/anilistcdn/character/large/b127278-0qCQciTkPOMS.jpg", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
  {
    id: "530",
    type: "ANIME",
    title: "미소녀전사 세일러문",
    nativeTitle: "美少女戦士セーラームーン",
    siteUrl: "https://anilist.co/anime/530",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx530-O8q6KpJ244Qk.jpg",
    description: "팀 구성이 선명한 마법소녀 작품. 단체 코스와 역할별 컬러 구분에 적합합니다.",
    genres: ["Action", "Fantasy", "Romance"],
    tags: ["Magic", "Super Power", "Female Protagonist"],
    seasonYear: 1992,
    characters: [
      { id: "2030", name: "츠키노 우사기", nativeName: "月野うさぎ", siteUrl: "https://anilist.co/character/2030", image: "https://s4.anilist.co/file/anilistcdn/character/large/b2030-GQvVYPEYkXCy.jpg", role: "MAIN" },
      { id: "2366", name: "미즈노 아미", nativeName: "水野亜美", siteUrl: "https://anilist.co/character/2366", image: "https://s4.anilist.co/file/anilistcdn/character/large/b2366-IJmfKZoSYT3N.png", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
  {
    id: "140960",
    type: "ANIME",
    title: "SPY×FAMILY",
    nativeTitle: "SPY×FAMILY",
    siteUrl: "https://anilist.co/anime/140960",
    coverImage: "https://s4.anilist.co/file/anilistcdn/media/anime/cover/medium/bx140960-Kb6R5nYQfjmP.jpg",
    description: "가족 위장 작전을 다룬 액션 코미디. 정장·교복·드레스 등 예산과 활동성에 맞춘 선택 폭이 넓습니다.",
    genres: ["Action", "Comedy", "Slice of Life"],
    tags: ["Family Life", "Espionage", "Found Family"],
    seasonYear: 2022,
    characters: [
      { id: "138100", name: "아냐 포저", nativeName: "アーニャ・フォージャー", siteUrl: "https://anilist.co/character/138100", image: "https://s4.anilist.co/file/anilistcdn/character/large/b138100-4Li0tWRCa5bQ.png", role: "MAIN" },
      { id: "138102", name: "요르 포저", nativeName: "ヨル・フォージャー", siteUrl: "https://anilist.co/character/138102", image: "https://s4.anilist.co/file/anilistcdn/character/large/b138102-ZOAu9jI2d5ke.png", role: "MAIN" },
      { id: "138101", name: "로이드 포저", nativeName: "ロイド・フォージャー", siteUrl: "https://anilist.co/character/138101", image: "https://s4.anilist.co/file/anilistcdn/character/large/b138101-7NCB0Md8zA6G.png", role: "MAIN" },
    ],
    source: "해볼캐 seed",
    sourceCheckedAt: checkedAt,
  },
];

export function catalogSeedFor(type: "ANIME" | "MANGA"): CatalogMedia[] {
  if (type === "ANIME") return catalogSeed;
  return catalogSeed.map((media) => ({
    ...media,
    id: mangaBySeedId[media.id].id,
    type: "MANGA",
    siteUrl: mangaBySeedId[media.id].siteUrl,
    characters: media.characters.map((character) => ({
      ...character,
      id: `${character.id}-manga`,
    })),
  }));
}
